<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <form id='roleForm'>
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.Role.name')}}:</div>
              <input id="roleName" class="e-input e-input-group" maxLength="25" name="RoleName" v-model="roleName" :placeholder="$t('Security.inputRoleName')" @change="setChildProps" @keydown="stopEvent"/>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.User.desc')}}:</div>
        <ejs-textbox id="description" name="Description" maxLength="50" v-model="description" :multiline="true" @change="setChildProps" />
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <ejs-grid ref="grid" height='380px' :allowSelection="true" :selectionSettings='selectionOptions' :rowSelected="setChildProps" :rowDeselected="setChildProps" :dataBound='dataBoundFunc'>
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="userId" :visible="false"></e-column>
            <e-column field="username" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
            <e-column field="realName" :headerText="$t('Security.User.realname')" width="120" textAlign="Center"></e-column>
            <e-column field="status" :headerText="$t('Security.User.status')" width="120" textAlign="Center"></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../mixin/mixin';

export default {
  name: "AddRoleP1",
  mixins: [mixin],
  data() {
    return {
      roleName: "",
      description: "",
      roleId: "",
      checked: [],
      inputNames: ['RoleName'],
      rules: { RoleName: { required: true }},
      selectionOptions: { type: 'Multiple' },
      formObj: '',
      data: [],
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
    };
  },
  methods: {
    queryRole() {
      const url = '/lte/ems/user/findAccountList';
      const params = {
        roleId: this.roleId
      };
      this.axios.get(url, { params }).then(response => {
        const result = response.data;
        let showRe = [];
        result.forEach(item => {
          let re = {};
          re.userId = item.userId;
          re.username = item.username;
          re.realName = item.realName;
          re.createTime = new Date(item.createTime);
          re.status = item.statusName;
          re.creator = item.creator;
          showRe.push(re);
        });
        this.data = showRe;
        this.$refs.grid.ej2Instances.dataSource = showRe;
      });
    },
    queryUserRole(src, checked) {
      // 设置数据初始勾选状态
      const indexes = [];
      checked.forEach(item => {
        indexes.push(src.findIndex(r => item == r.userId));
      });
      this.$refs.grid.ej2Instances.selectRows(indexes);
    },
    dataBoundFunc() {
      const indexes = [];
      this.checked.forEach(item => {
        indexes.push(this.data.findIndex(r => item == r.userId));
      });
      this.$refs.grid.ej2Instances.selectRows(indexes);
      this.setChildProps();
    },
    setChildProps() {
      const records = this.$refs.grid.ej2Instances.getSelectedRecords();
      const selected = [];
      records.forEach(item => {
        selected.push(item.userId);
      });
      this.$emit("childProps", {
        roleName: this.roleName,
        description: this.description,
        selected: selected
      });
    },
    init(roleParams) {
      document.getElementById("roleName").disabled = true;
      this.roleName = roleParams.roleName;
      this.description = roleParams.description;
      this.roleId = roleParams.roleId;
      this.checked = roleParams.accountIdList;
    },
    bindValidate() {
      this.formObj = this.validateForm('roleForm', this.inputNames, this.rules);
    },
    validation() {
      return this.formObj.validate();
    },
    stopEvent(event) {
      if (event.keyCode == 13) {
        event.cancelBubble = true;
        event.returnValue = false;
        return false;
      }
    }
  }
};
</script>
